import React from "react";
import {Card} from "react-bootstrap";
import {SettingsDoc, User} from "../types/Types";
import PageTracking from "../auth/PageTracking";

interface Props {
    currentUser: User | undefined;
    settings: SettingsDoc | undefined;
}

interface UpdateCard {
    date: string;
    updates: string[];
}

/**
 * Ideas:
 *   - Add year filters to user points page
 *   - Add year filter to checkin leaderboard
 *   - Improve the support page 
 */

function WhatsNew(props: Props) {
    // For now, just one update card as requested
    const updateCards: UpdateCard[] = [
        {
            date: "3rd November 2026",
            updates: [
                "Enabled Google sign in - you can now use your Google account to sign in or register.",
                "Added an optional new UI - you can switch to the new interface from Settings.",
                "Added the ability to record and track hotel stays.",
            ]
        },
        {
            date: "13th September 2026",
            updates: [
                "To check out you now need to be in the same pub which you originally checked into.",
                "You can now see your check-in history on the map page through the new toggle option."
            ]
        },
        {
            date: "4th July 2026",
            updates: [
                "Added pub tag search - you can now filter the Pubs page by tags.",
            ]
        },
        {
            date: "29th June 2026",
            updates: [
                "Added pub tags - you can now add helpful tags like beer garden, terrace, good a/c, and accessibility details.",
            ]
        },
        {
            date: "21st June 2026",
            updates: [
                "Added a new university category for pubs",
                "Tightened up the check-in process by adding a cool down period to prevent rapid repeated check-ins.",
            ]
        },
        {
            date: "14th May 2026",
            updates: [
                "Added the ability to sort by age on the Pubs page.",
            ]
        },
        {
            date: "13th May 2026",
            updates: [
                "Improved 'Find your nearest pub' - you can now search for the nearest pub overall, nearest pub not yet visited, or nearest pub not yet checked into.",
            ]
        },
        {
            date: "3rd April 2026",
            updates: [
                "Added Spain bonus points - users now receive bonus points when checking into pubs in Spain.",
            ]
        },
        {
            date: "28th March 2026",
            updates: [
                "Added emoji reactions to chat messages - you can now react to messages with emojis by tapping on any message bubble.",
            ]
        },
        {
            date: "24th March 2026",
            updates: [
                "Added a 'Unique Check-ins' option on the user profile - you can now see a list of all the unique pubs you've checked into and the distance and length of time between visits.",
                "Added a 'Journey' page to map check-in history over time",
            ]
        },
        {
            date: "26th February 2026",
            updates: [
                "Added support for multiple badges per user - users can now obtain and organise multiple badges.",
            ]
        },
        {
            date: "3rd February 2026",
            updates: [
                "Added a CSV export button to the user profile page - you can now download your visit history.",
            ]
        },
        {
            date: "2nd February 2026",
            updates: [
                "Added a country field to each pub's address - you can now see which country each pub is located in on the pub details page.",
            ]
        },
        {
            date: "3rd November 2025",
            updates: [
                "Added a new 'Calendar' page - view upcoming planned pub openings and closings.",
            ]
        },
        {
            date: "1st November 2025",
            updates: [
                "Added a new Photos leaderboard under the Users section",
                "Added a new 'Photo of the Month' widget to the home screen",
            ]
        },
        {
            date: "30th October 2025",
            updates: [
                "Added the ability to like pubs - you can now like your favorite pubs by clicking the heart icon on the pub's page",
                "Added sorting by likes on the Pubs page - sort pubs by most liked using the heart button",
            ]
        },
        {
            date: "27th October 2025",
            updates: [
                "Added percentage completion stats to the user profile visits page",
            ]
        },
        {
            date: "19th October 2025",
            updates: [
                "Added the ability to like comments, including a sort by most liked option on the comments page",
            ]
        },
        {
            date: "18th October 2025",
            updates: [
                "Added 'Top liked photos' section to the photos page",
                "Added 'User likes' page showing when you have liked a photo",
                "Added description field to photos - you can now add and edit descriptions for your uploaded photos",
            ]
        },
        {
            date: "17th October 2025",
            updates: [
                "Added sorting options to photo tag views - sort photos by date or by most liked using the new filter buttons",
                "Improved the 'Add Photo' screen to include auto-suggestions for popular tags",
            ]
        },
        {
            date: "15th October 2025",
            updates: [
                "Added photo liking functionality - you can now like photos by clicking the heart icon",
                "Added a new 'Latest News' widget to the home page showing the top Wetherspoon news headlines",
            ]
        },
        {
            date: "13th October 2025",
            updates: [
                "Improved the photo display to always include tags, the user who uploaded it, and the location",
                "Limited the number of tags shown on initial display of the photos page",
            ]
        },
        {
            date: "12th October 2025",
            updates: [
                "Added an 'Updates' page to keep users informed of latest features",
                "Added a settings toggle so you can hide visited closed pubs on the map",
            ]
        }
    ];

    return (
        <>
            <PageTracking />
            {updateCards.map((update, index) => (
                <Card key={index} className={index === 0 ? "" : "mt-3"}>
                    <Card.Header>
                        <div><b>{update.date}</b></div>
                    </Card.Header>
                    <Card.Body>
                        <ul className="bullet-points">
                            {update.updates.map((updateItem, itemIndex) => (
                                <li key={itemIndex}>
                                    <div className="mb-2">{updateItem}</div>
                                </li>
                            ))}
                        </ul>
                    </Card.Body>
                </Card>
            ))}
        </>
    );
}

export default WhatsNew;
